import type { GetEventsForPerformanceEntries } from '../types';

import { isReportableResourceEntry } from './isReportableResourceEntry';
import { getResourcePerformanceEvent } from './resourcePerformanceEvent';

export const getEventsForResourceEntries: GetEventsForPerformanceEntries = (entries) =>
  entries
    .filter((entry) => isReportableResourceEntry(entry as PerformanceResourceTiming))
    .map((en) => getResourcePerformanceEvent(en as PerformanceResourceTiming));
